import React from 'react';
import { createPortal } from 'react-dom';
import { Button, Modal, Tooltip } from 'antd';
import { MessageOutlined } from '@ant-design/icons';
import FeedbackForm, { installFeedbackLogCollector } from './FeedbackForm';
import './GlobalFeedbackButton.css';

export default class GlobalFeedbackButton extends React.Component {
  state = { visible: false };

  componentDidMount() {
    installFeedbackLogCollector();
  }

  open = () => this.setState({ visible: true });
  close = () => this.setState({ visible: false });

  render() {
    const content = (
      <>
        <Tooltip title="反馈问题">
          <Button
            type="primary"
            shape="circle"
            icon={<MessageOutlined />}
            className="sj-feedback-button"
            aria-label="反馈问题"
            onClick={this.open}
          />
        </Tooltip>
        <Modal
          title="问题反馈"
          open={this.state.visible}
          zIndex={4100}
          onCancel={this.close}
          footer={null}
        >
          <FeedbackForm user={this.props.user} onSubmitted={this.close} />
        </Modal>
      </>
    );

    if (typeof document !== 'undefined' && document.body) {
      return createPortal(content, document.body);
    }
    return content;
  }
}
